import { get } from "svelte/store"
import { apiBaseOverride } from "../../../_shared/_logic/store"
import { baseAPIURL } from "../../_shared/_logic/config"
import { parseApiErrorPayload, resolveApiErrorMessage } from "../../error-message"
import { ApiError } from "../presentation"

type PublicShortCodeResolveResponse = {
  target_path: string
}

const resolveBaseUrl = () => {
  const override = get(apiBaseOverride)

  return override ?? baseAPIURL
}

const joinUrl = (path: string) => {
  const base = resolveBaseUrl().replace(/\/+$/, "")
  const normalized = path.startsWith("/") ? path : `/${path}`

  return `${base}${normalized}`
}

export const resolvePublicShortCode = async (code: string): Promise<string> => {
  const normalizedCode = code?.trim()

  if (!normalizedCode) {
    throw new ApiError(400, "Ungültiger Termincode.")
  }

  const response = await fetch(joinUrl(`/public/short-codes/${encodeURIComponent(normalizedCode)}`))

  if (!response.ok) {
    const { detail } = await parseApiErrorPayload(response)
    const message = resolveApiErrorMessage(detail, {
      statusCode: response.status,
      statusText: response.statusText,
    })
    throw new ApiError(response.status, message, detail)
  }

  const payload = (await response.json()) as PublicShortCodeResolveResponse

  return payload.target_path
}
